import numericSize, { NUMERIC_TYPE } from './numeric-size';
import predefinedSize, { PREDEFINED_TYPE } from './predefined-size';

/**
 * Фабрика для свойств типа size-trait
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-size-trait.json
 * @param {Number|String} data.value
 * @param {String} data.type
 * @param {String} data.unit
 * @param {Object} defaultValue
 * @return {NumericSize|PredefinedSize}
 */
export default (function (data) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (!data || !data.type) {
        return defaultValue;
    }

    switch (data.type) {
        case NUMERIC_TYPE:
            return numericSize(data, defaultValue);
        case PREDEFINED_TYPE:
            return predefinedSize(data, defaultValue);
        default:
            return defaultValue;
    }
});